import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as sisMapActions from "store/modules/rds_sisMap";
import $ from "jquery";
import { LoadingContext } from "../../loadingContext";

import "./culture.scss";

import { IoIosArrowForward } from "react-icons/io";
import { MdClose } from "react-icons/md";

import SisSelect from "store/sis/component/SisSelect";
import SisOverlay from "store/sis/SisOverlay";

class Culture extends Component {
	static contextType = LoadingContext; // contextType 사용
	state = {
		title: "문화",
		activeItem: "",
		lstEmd: [],
		lstYmd: [],
		lstGb: [],
		source:"",
	};

	openSearchWrap = (evt) => {
		$("#cultureWrap .itemsWrap").hide();
		$("#cultureWrap .searchWrap").show();
		$("#cultureWrap .close").show();
		$(".source").show();
		$("#cultureWrap .searchWrap").css("top","60px");		

		const id = $(evt.target).closest(".item").attr("id");
		const title = $(evt.target).closest(".item").find("span").text();
		let source = "";

		

		if(id=="library"){
			this.getYmd("library_info");		
			//this.getGb(id);
			source = "문화유산과";
		}else if(id=="cultPerf"){
			this.getYmd("cult_perf");		
			//this.getGb(id);
			source = "전남광주통합특별시";
		}else if(id=="cultExhi"){
			this.getYmd("cult_exhi");		
			//this.getGb(id);
			source = "전남광주통합특별시";
		}else if(id=="cultWelf"){
			this.getYmd("cult_welf");		
			//this.getGb(id);
			source = "전남광주통합특별시";
		}else if(id=="cultDist"){
			this.getYmd("cult_dist");		
			//this.getGb(id);
			source = "전남광주통합특별시";
		}
		this.setState({
			activeItem: id,
			title,
			source,
		});
	};

	closeSearchWrap = () => {
		$("#cultureWrap .searchWrap").hide();
		$("#cultureWrap .itemsWrap").show();
		$("#apartModal .close").click();
		$(".tabWrap .tab.active .searchWrap .listWrap").remove();
		$("#cultureWrap .close").hide();
		$(".source").hide();
		$("#cultureWrap .searchWrap").css("top","");

		this.setState({
			activeItem: "",
			title: "문화",
		});

	};

	// 읍면동 불러오기
	getEmd = (value) => {
		let lstEmd = [];

		$.ajax({
			url: "/map/getEmd",
			type: "post",
			data: {
				value,
			},
			success: (res) => {
				lstEmd = res;

				this.setState({
					lstEmd: [{ emdCd: "0", emdNm: "=== 전체 ===" }, ...lstEmd],
				});
			},
		});
	};

	//년도 가져오기
	getYmd = (value) => {
		let lstYmd = [];

		$.ajax({
			url: "/map/getYmd",
			type: "post",
			data: {
				value,
			},
			success: (res) => {
				
				lstYmd = res;

				this.setState({
					lstYmd: [...lstYmd],
				});
			},
		});
	};

	//그룹 가져오기
	getGb = (id) => {
		let lstGb = [];

		if(id==="park"){
			lstGb = [
				{facilitiesGb:'근린공원',facilitiesNm:'근린공원'}, 
				{facilitiesGb:'소공원', facilitiesNm:'소공원'},
				{facilitiesGb:'어린이공원', facilitiesNm:'어린이공원'},
				{facilitiesGb:'주제공원', facilitiesNm:'주제공원'}
			];
		}
		this.setState({
			lstGb: [{ facilitiesGb: "0", facilitiesNm: "=== 전체 ===" }, ...lstGb],
		});		
	};

	// 오버레이 클릭 이벤트(모달)
	_overlayClickEvent = (ele, id, activeItem, noProps = false,mapZoom = false) => {
		const { actions, layout, sis } = this.props;
		let overlayElement;
		let col;

		 if (activeItem === "library") {
			overlayElement = (
				<>
					<div
						className="sisOverlayClose"
						onClick={() => {
							$(`#${id}`).remove();
						}}
					>
						<MdClose size="25px" />
					</div>

					<span className="cultureTitle">{ele.libraryNm}</span>
					<span className="cultureAddress">
						{ele.address}
					</span>

					
					<table>
						<caption>도서관</caption>
						<tbody>
							<tr>
								<th>전화번호</th>
								<td>{ele.libraryTel ? ele.libraryTel : "-"}</td>
							</tr>
							<tr>
								<th>도서수</th>
								<td>{ele.bookCnt != null && !isNaN(Number(ele.bookCnt)) ? Number(ele.bookCnt).toLocaleString() : "-"}</td>
							</tr>
							<tr>
								<th>좌석수</th>
								<td>{ele.seatCnt != null && !isNaN(Number(ele.seatCnt)) ? Number(ele.seatCnt).toLocaleString() : "-"}</td>
							</tr>
							<tr>
								<th>회원수</th>
								<td>{ele.memberCnt != null && !isNaN(Number(ele.memberCnt)) ? Number(ele.memberCnt).toLocaleString() : "-"}</td>
							</tr>					
						</tbody>
					</table>
					{/*<span className="cultureTel">전화번호 : {ele.libraryTel ? ele.libraryTel : "-"}</span>
					<span >도서수 : {ele.bookCnt ? ele.bookCnt : "-"}</span>
					<span >좌석수 : {ele.seatCnt ? ele.seatCnt : "-"}</span>
					<span >회원수 : {ele.memberCnt ? ele.memberCnt : "-"}</span>*/}

					
				</>
			);
		} else if (activeItem === "cultPerf") {
			overlayElement = (
				<>
					<div
						className="sisOverlayClose"
						onClick={() => {
							$(`#${id}`).remove();
						}}
					>
						<MdClose size="25px" />
					</div>

					<span className="cultureTitle">{ele.cultNam}</span>
					<span className="cultureAddress">
						{ele.cultAddr}
						<br/>
						{ele.cultRoad}
					</span>
					<table>
						<caption>공연시설</caption>
						<tbody>
							<tr>
								<th className="cultureTel">전화번호</th>
								<td>{ele.cultTel ? ele.cultTel : "-"}</td>
							</tr>
							<tr>
								<th>시설구분</th>
								<td>{ele.cultGbn ? ele.cultGbn : "-"}</td>
							</tr>
							<tr>
								<th>수용인원(명)</th>
								<td>{ele.cultPers != null && !isNaN(Number(ele.cultPers)) ? Number(ele.cultPers).toLocaleString() : "-"}</td>
							</tr>
							<tr>
								<th>객석면적(m²)</th>
								<td>{ele.cultPear != null && !isNaN(Number(ele.cultPear)) ? Number(ele.cultPear).toLocaleString() : "-"}</td>
							</tr>
							<tr>
								<th>무대면적(m²)</th>
								<td>{ele.cultRear != null && !isNaN(Number(ele.cultRear)) ? Number(ele.cultRear).toLocaleString() : "-"}</td>
							</tr>					
						</tbody>
					</table>
					{/*<span className="cultureTel">시설구분 : {ele.cultGbn ? ele.cultGbn : "-"}</span>
					<span >수용인원(명) : {ele.cultPers ? ele.cultPers : "-"}</span>
					<span >객석면적(m²) : {ele.cultPear ? ele.cultPear : "-"}</span>
					<span >무대면적(m²): : {ele.cultRear ? ele.cultRear : "-"}</span>
					<span >전화번호 : {ele.cultTel ? ele.cultTel : "-"}</span>
					{ele.cultArea && !isNaN(Number(ele.cultArea)) ? Number(ele.cultArea).toLocaleString() : "-"}*/
					}
				</>
			);
		} else if (activeItem === "cultExhi") {
			overlayElement = (
				<>
					<div
						className="sisOverlayClose"
						onClick={() => {
							$(`#${id}`).remove();
						}}
					>
						<MdClose size="25px" />
					</div>

					<span className="cultureTitle">{ele.cultNam}</span>
					<span className="cultureAddress">
						{ele.cultAddr}
						<br/>
						{ele.cultRoad}
					</span>
					<table>
						<caption>전시시설</caption>
						<tbody>
							<tr>
								<th className="cultureTel">전화번호</th>
								<td>{ele.cultTel ? ele.cultTel : "-"}</td>
							</tr>
							<tr>
								<th>시설구분</th>
								<td>{ele.cultGbn ? ele.cultGbn : "-"}</td>
							</tr>
							<tr>
								<th>수용인원(명)</th>
								<td>{ele.cultPers != null && !isNaN(Number(ele.cultPers)) ? Number(ele.cultPers).toLocaleString() : "-"}</td>
							</tr>
							<tr>
								<th>면적(m²)</th>
								<td>{ele.cultArea != null && !isNaN(Number(ele.cultArea)) ? Number(ele.cultArea).toLocaleString() : "-"}</td>
							</tr>				
						</tbody>
					</table>
					{/*<span className="cultureTel">시설구분 : {ele.cultGbn ? ele.cultGbn : "-"}</span>
					<span >수용인원(명) : {ele.cultPers ? ele.cultPers : "-"}</span>
					<span >면적(m²) : {ele.cultArea ? ele.cultArea : "-"}</span>					
					<span >전화번호 : {ele.cultTel ? ele.cultTel : "-"}</span>*/}

					
				</>
			);
		}  else if (activeItem === "cultDist") {
			overlayElement = (
				<>
					<div
						className="sisOverlayClose"
						onClick={() => {
							$(`#${id}`).remove();
						}}
					>
						<MdClose size="25px" />
					</div>

					<span className="cultureTitle">{ele.cultNam}</span>
					<span className="cultureAddress">
						{ele.cultAddr}
						<br/>
						{ele.cultRoad}
					</span>
					<table>
						<caption>지방문화원</caption>
						<tbody>
							<tr>
								<th className="cultureTel">전화번호</th>
								<td>{ele.cultTel ? ele.cultTel : "-"}</td>
							</tr>
							<tr>
								<th>시설구분</th>
								<td>{ele.cultGbn ? ele.cultGbn : "-"}</td>
							</tr>
							<tr>
								<th>수용인원(명)</th>
								<td>{ele.cultPers != null && !isNaN(Number(ele.cultPers)) ? Number(ele.cultPers).toLocaleString() : "-"}</td>
									{/*{ele.cultPers.toLocaleString() ? ele.cultPers.toLocaleString() : "-"}*/}
							</tr>
							<tr>
								<th>면적(m²)</th>
								<td>{ele.cultArea != null && !isNaN(Number(ele.cultArea)) ? Number(ele.cultArea).toLocaleString() : "-"}</td>
							</tr>				
						</tbody>
					</table>
					{/*<span className="cultureTel">시설구분 : {ele.cultGbn ? ele.cultGbn : "-"}</span>
					<span >수용인원(명) : {ele.cultPers ? ele.cultPers : "-"}</span>
					<span >면적(m²) : {ele.cultArea ? ele.cultArea : "-"}</span>					
					<span >전화번호 : {ele.cultTel ? ele.cultTel : "-"}</span>*/}	
				</>
			);
		} else {
			overlayElement = (
				<>
					<div
						className="sisOverlayClose"
						onClick={() => {
							$(`#${id}`).remove();
						}}
					>
						<MdClose size="25px" />
					</div>

					<span className="cultureTitle">{ele.infDskNm}</span>
					<span className="cultureAddress">
						{ele.roadAddr}
						<br />
						{ele.addr}
					</span>
					<span className="cultureTel">전화번호 : {ele.tel ? ele.tel : "-"}</span>
					<span>홈페이지 : {ele.homepage ? ele.homepage : "-"}</span>
					<span className="cultureInfo">- 소개 -</span>
					<span>{ele.infDskIntrd ? ele.infDskIntrd : "-"}</span>
				</>
			);
		}

		let overlay = sis.sisMap.map.getOverlayById("overlaySelector");
		sis.sisMap.map.removeOverlay(overlay);

		actions.addResultOverlay({
			element: overlayElement,
			data: ele,
			id,
			className: "removeOverlayWrap",
			isTop: true,
			noProps,
			mapZoom,
		});
	};

	// 오버레이 클릭 이벤트(겹치는거 확인)
	overlayClickEvent = (ele, evt, overlay) => {
		const { actions, layout, sis } = this.props;

		let col = "";
		const activeItem = $(evt.target).closest(".sisOverlayWrap").find("span:first").attr("class");
		const id = `culture_${activeItem}_removeOverlay`;
		$(`#${id}`).remove();

		let existOverlay = sis.sisMap.map.getOverlayById(id);
		if (existOverlay) sis.sisMap.map.removeOverlay(existOverlay);

		/*if (activeItem === "museum") col = "fcltyNm";
		else if (activeItem === "sightseeing") col = "trrsrtNm";
		else*/if (activeItem === "library") col = "libraryNm";
		else if (activeItem === "cultPerf") col = "cultNam";
		else if (activeItem === "cultExhi") col = "cultNam";
		else if (activeItem === "cultDist") col = "cultNam";
		else col = "infDskNm";

		const arrOverlays = [];
		const pos = overlay.getPosition();
		const interval = 1;
		let xInterval = 0;
		let yInterval = 0;
		const overlays = sis.sisMap.map.getOverlays().getArray();

		$.each(overlays, (idx, item) => {
			let targetPos = item.getPosition();

			if (targetPos) {
				targetPos = targetPos;

				xInterval = Math.abs(pos[0] - targetPos[0]);
				yInterval = Math.abs(pos[1] - targetPos[1]);

				if (xInterval <= interval && yInterval <= interval) {
					arrOverlays.push(item);
				}
			}
		});

		if (arrOverlays.length > 1) {
			
			// if (true) {
			// 오버레이 생성
			const overlayElement = document.createElement("div");
			document.body.appendChild(overlayElement);
			overlayElement.className = "overlaySelector";
			overlayElement.id = "overlaySelector";

			let overlay = sis.sisMap.map.getOverlayById("overlaySelector");

			if (overlay) sis.sisMap.map.removeOverlay(overlay);
			overlay = new SisOverlay(`#overlaySelector`, sis.sisMap.map, "bottom-center", [0, 0]);
			overlay.setPosition(pos);
			$(overlayElement).parent().css("z-index", 9999);

			arrOverlays.forEach((item) => {
				const props = item.getProperties();

				if (props[col]) {
					const element = document.createElement("div");
					element.innerText = props[col];
					$(overlayElement).append(element);

					$(element).on("click", () => {
					this._overlayClickEvent(props, id, activeItem, true);
					sis.sisMap.map.removeOverlay(overlay);
					});
				}

				// $(overlayElement).append(`<div>${props.buildNm}</div>`);
			});
			
		} else {
		this._overlayClickEvent(ele, id, activeItem);
		}

		return;
	};

	// 오버레이 생성
	createOverlay = (data, id) => {
		const { actions } = this.props;
		const { activeItem } = this.state;

		$(".tabWrap .tab.active .searchWrap .listWrap").remove();
		$(".tabWrap .tab.active .searchWrap").append("<div class='listWrap'><span class='cnt'>검색결과 <a>" + data.length.toLocaleString() + "</a>건</span></div>");

		data.forEach((ele, idx) => {
			let overlayElement;

			/*if (activeItem === "museum") {
				overlayElement = (
					<>
						<span className={activeItem}>{ele.fcltyNm}</span>
					</>
				);
				$(".tabWrap .tab.active .searchWrap .listWrap").append(`<span class=lst_${id}_${ele.gid}>${ele.fcltyNm}</span>`);
			} else if (activeItem === "sightseeing") {
				overlayElement = (
					<>
						<span className={activeItem}>{ele.trrsrtNm}</span>
					</>
				);
				$(".tabWrap .tab.active .searchWrap .listWrap").append(`<span class=lst_${id}_${ele.gid}>${ele.trrsrtNm}</span>`);
			} else */if (activeItem === "library") {
				overlayElement = (
					<>
						<span className={activeItem}>{ele.libraryNm}</span>
					</>
				);
				//$(".tabWrap .tab.active .searchWrap .listWrap").append(`<span class=lst_${id}_${ele.gid}>${ele.libraryNm}</span>`);
			} else if (activeItem === "cultPerf") {
				overlayElement = (
					<>
						<span className={activeItem}>{ele.cultNam}</span>
					</>
				);
				//$(".tabWrap .tab.active .searchWrap .listWrap").append(`<span class=lst_${id}_${ele.gid}>${ele.cultNam}</span>`);
			}else if (activeItem === "cultExhi") {
				overlayElement = (
					<>
						<span className={activeItem}>{ele.cultNam}</span>
					</>
				);
				//$(".tabWrap .tab.active .searchWrap .listWrap").append(`<span class=lst_${id}_${ele.gid}>${ele.cultNam}</span>`);
			}else if (activeItem === "cultDist") {
				overlayElement = (
					<>
						<span className={activeItem}>{ele.cultNam}</span>
					</>
				);
				//$(".tabWrap .tab.active .searchWrap .listWrap").append(`<span class=lst_${id}_${ele.gid}>${ele.cultNam}</span>`);
			} else {
				overlayElement = (
					<>
						<span className={activeItem}>{ele.cultNam}</span>
					</>
				);
				//$(".tabWrap .tab.active .searchWrap .listWrap").append(`<span class=lst_${id}_${ele.gid}>${ele.cultNam}</span>`);
			}

			// $(`.lst_${id}_${ele.gid}`).on("click", () => {
			// 	$(`#${id}_${ele.gid}`)[0].click();

			// 	const feature = this.props.sis.sisLayer.createFeatureByWKT(ele.geom);
			// 	feature.getGeometry().transform("EPSG:5186", "EPSG:5181");
			// 	this.props.sis.sisMap.view.fit(feature.getGeometry().getExtent());
			// 	this.props.sis.sisMap.view.setZoom(8);
			// });

			actions.addResultOverlay({
				element: overlayElement,
				data: ele,
				id: `${id}_${ele.gid}`,
				className: "cultureOverlayWrap",
				onClick: this.overlayClickEvent,
				minZoom: 6,
				maxZoom: 10,
			});
		});
		// 오버레이 클릭 이벤트
		data.forEach((ele, idx) => {
			let overlayElement;
			if (activeItem==="library") {
				//$(".tabWrap .tab.active .searchWrap .listWrap").append(`<span class=lst_${id}_${ele.gid}>${ele.equipNm}</span>`);

				$(".tabWrap .tab.active .searchWrap .listWrap").append(
					`<span class="lst_${id}_${ele.gid}" 
						data-ele='${JSON.stringify(ele).replace(/'/g, "&apos;")}' 
						data-id='${id}' 
						data-active-item='${activeItem}'>
					${ele.libraryNm}
					</span>`
				);
			} else if (activeItem==="cultPerf"){
				$(".tabWrap .tab.active .searchWrap .listWrap").append(
					`<span class="lst_${id}_${ele.gid}" 
						data-ele='${JSON.stringify(ele).replace(/'/g, "&apos;")}' 
						data-id='${id}' 
						data-active-item='${activeItem}'>
					${ele.cultNam}
					</span>`
				);
			}	else if (activeItem==="cultExhi"){
				$(".tabWrap .tab.active .searchWrap .listWrap").append(
					`<span class="lst_${id}_${ele.gid}" 
						data-ele='${JSON.stringify(ele).replace(/'/g, "&apos;")}' 
						data-id='${id}' 
						data-active-item='${activeItem}'>
					${ele.cultNam}
					</span>`
				);
			}else if (activeItem==="cultWelf"){
				$(".tabWrap .tab.active .searchWrap .listWrap").append(
					`<span class="lst_${id}_${ele.gid}" 
						data-ele='${JSON.stringify(ele).replace(/'/g, "&apos;")}' 
						data-id='${id}' 
						data-active-item='${activeItem}'>
					${ele.cultNam}
					</span>`
				);
			}else if (activeItem==="cultDist"){
				$(".tabWrap .tab.active .searchWrap .listWrap").append(
					`<span class="lst_${id}_${ele.gid}" 
						data-ele='${JSON.stringify(ele).replace(/'/g, "&apos;")}' 
						data-id='${id}' 
						data-active-item='${activeItem}'>
					${ele.cultNam}
					</span>`
				);
			}

			
		});

		$(".tabWrap .tab.active .searchWrap .listWrap").on("click", "span", (event) => {
			const target = $(event.currentTarget);
		
			const eleAttr = target.attr("data-ele");
			const id = target.attr("data-id")+"_removeOverlay";
			const activeItem = target.attr("data-active-item");
		
			if (!eleAttr) {
				console.error("data-ele 값이 없습니다.");
				return;
			}
		
			try {
				// JSON.parse() 한 번만 실행
				const ele = JSON.parse(eleAttr);
				
				// `this._overlayClickEvent()`를 호출하도록 변경 (화살표 함수 덕분에 this 유지됨)
				if (typeof this._overlayClickEvent === "function") {
					const mapZoom = true;
					const noProps = false;
					this._overlayClickEvent(ele, id, activeItem,noProps,mapZoom);
				} else {
					console.error("_overlayClickEvent 함수가 존재하지 않습니다.");
				}
			} catch (error) {
				console.error("JSON 파싱 오류:", error);
			}
		});

		if(activeItem === "library"||activeItem==="cultPerf"||activeItem==="cultExhi"||activeItem==="cultDist"){
			$(".tabWrap .tab.active .searchWrap .listWrap").css("top","225px");
		}
	};

	// 검색
	search = async (evt, id) => {
		const { setLoading } = this.context; // context에서 setLoading 가져오기
    	setLoading(true); 
		const { activeItem } = this.state;
		const { actions, sis } = this.props;

		let stdYmd = document.querySelector("select#selectEnvironmentStdYmd");
		// stdYmd 값을 select에서 직접 가져오기
		if (stdYmd) {
			stdYmd = stdYmd.value ;
		} else {
			stdYmd = null;  // 요소가 없으면 기본값 null 설정
		}

		// 기준년도 값이 없으면 1초 대기 후 실행
		const waitForStdYmd = () => {
			return new Promise(resolve => {
			  if (!stdYmd || stdYmd.trim() === "") {
				//console.log("기준년도 값이 없습니다. 1초 대기 중...");
				// 1초 대기 후, resolve를 호출하여 대기 끝냄
				setTimeout(() => {
				  resolve(); // Promise를 해결하여 대기 종료
				}, 1000);
			  } else {
				//console.log("기준년도 값이 있습니다.");
				resolve(); // 바로 resolve하여 대기 없이 진행
			  }
			});
		  };
		
		  // 비동기적으로 처리할 함수
		  await waitForStdYmd(); // 기준년도 값이 없으면 1초 기다리기

		let title = "";
		let data = [];
		//let stdYmd = "";
		let guBun = "0";
		if(activeItem==="library"||activeItem==="cultPerf"||activeItem==="cultExhi"||activeItem==="cultDist"){
			stdYmd = $("select#selectEnvironmentStdYmd").val() || $("select#selectEnvironmentStdYmd option:first").val() || "0";
			//guBun = $("select#selectEnvironmentGb").val();
		}

		if(guBun==null){
			guBun = "0";
		}
		let params = {
			sggCode: $("select#selectCultureSgg").val(),
			emdCode: $("select#selectCultureEmd").val(),
			stdYmd: stdYmd,
			guBun: guBun,
		};
		let color = "#ff0000";
		let url = "";
		let legend = "";
		// debugger;
		/*if (activeItem === "museum") {
			title = "박물관, 미술관";
			color = "#e91e63";
			url = "/map/selectMuseumList";
		} else if (activeItem === "sightseeing") {
			title = "주요관광지";
			color = "#ec407a";
			url = "/map/selectTnPubrPublic";
		}else*/ if (activeItem === "library") {
			title = "도서관위치 현황";
			color = "#ec407a";
			url = "/map/selectLibrary";
		}else if (activeItem === "cultPerf") {
			title = "공연시설 현황";
			color = "#ec407a";
			url = "/map/selectCultPerf";
		}else if (activeItem === "cultExhi") {
			title = "전시시설 현황";
			color = "#ec407a";
			url = "/map/selectCultExhi";
		}else if (activeItem === "cultDist") {
			title = "지방문화원 현황";
			color = "#ec407a";
			url = "/map/selectCultDist";
		} else {
			title = "관광안내소";
			color = "#f48fb1";
			url = "/map/selectTnInformation";
		}

		$.ajax({
			url,
			type: "post",
			data: params,
			success: (res) => {
				data = res.items ? res.items : res;

				if (data.length === 0) {
					alert("검색결과가 없습니다.");
					setLoading(false);
					return;
				}

				if (res.wkt) {
					const feature = sis.sisLayer.createFeatureByWKT(res.wkt);
					feature.getGeometry().transform("EPSG:5186", "EPSG:5181");
					const extent = feature.getGeometry().getExtent();

					sis.sisMap.view.fit(extent);
				}

				const lyr = sis.sisLayer.getLayerById(`culture_${activeItem}`);

				if (lyr) {
					actions.deleteResult({
						id: `culture_${activeItem}`,
						refresh: true,
					});
				}

				// 트리아이템 생성
				actions.addResultItem({
					data: legend,
					id: `culture_${activeItem}`,
					title,
					closeEvent: actions.deleteResult,
					checkboxEvent: actions.resultCheckboxHandler,
				});

				// 레이어 생성
				actions.addResultLayer({
					data,
					id: `culture_${activeItem}`,
					type: "point",
					color,
					callback: () => {
						requestAnimationFrame(() => {
							setLoading(false); // ✅ UI 업데이트가 끝난 후 실행
						  });
					  }
				});
				
				// 오버레이 생성
				this.createOverlay(data, `culture_${activeItem}`);
			},
		});
	};

	render() {
		const { activeItem } = this.state;
		const { lstSgg, defaultSggCd } = this.props.sis;
		let searchElement;

		if ("museum,sightseeing,information".indexOf(activeItem) > -1 && activeItem !== "") {
			searchElement = (
				<>
					<div className="inputWrap">
						<span className="selectTitle">구명</span>
						<SisSelect
							id="selectCultureSgg"
							className="select"
							items={lstSgg}
							mapping={{
								key: "sggCd",
								text: "sggNm",
							}}
							onChange={this.getEmd}
							onLoaded={this.getEmd}
						/>
					</div>
					<div className="inputWrap">
						<span className="selectTitle">동명</span>
						<SisSelect
							id="selectCultureEmd"
							className="select"
							mapping={{
								key: "emdCd",
								text: "emdNm",
							}}
							items={this.state.lstEmd}
						/>
					</div>

					<div className="btnWrap">
						<button id="btnSearch" onClick={(evt) => this.search(evt, activeItem)}>
							검색
						</button>
					</div>
				</>
			);
		}else if ("library,cultPerf,cultExhi,cultDist".indexOf(activeItem) > -1) {
			searchElement = (
				<>
					<div className="inputWrap">
						<span className="selectTitle">기준년도</span>
						<SisSelect
							id="selectEnvironmentStdYmd"
							ref={(ref) => (this.selectwelfareStdYmd = ref)}
							className="select"
							mapping={{
								key: "stdYmd",
								text: "stdName",
							}}
							items={this.state.lstYmd}
						/>
					</div>
					<div className="inputWrap">
						<span className="selectTitle">구명</span>
						<SisSelect
							id="selectCultureSgg"
							className="select"
							items={lstSgg}
							mapping={{
								key: "sggCd",
								text: "sggNm",
							}}
							onChange={this.getEmd}
							onLoaded={this.getEmd}
						/>
					</div>
					<div className="inputWrap">
						<span className="selectTitle">동명</span>
						<SisSelect
							id="selectCultureEmd"
							className="select"
							mapping={{
								key: "emdCd",
								text: "emdNm",
							}}
							items={this.state.lstEmd}
						/>
					</div>

					<div className="btnWrap">
						<button id="btnSearch" onClick={(evt) => this.search(evt, activeItem)}>
							검색
						</button>
					</div>
				</>
			);
		}

		return (
			<div id="cultureWrap" className="contentsWrap">
				<div className="title">
					<span>{this.state.title}</span>
					<div className="close" onClick={this.closeSearchWrap}>
						<MdClose />
					</div>
				</div>
				<div className="source" style={{display:"none"}}>
					<span className="origin_tit">출처</span>
					<span className="origin_stxt">{this.state.source}</span>
				</div>
				<div className="itemsWrap">
			

					<div id="library" className="item" onClick={this.openSearchWrap}>
						{/*	<img className="logo" alt="도서관 위치현황" src="/sis/images/map/culture/icInformation.png" />*/}
						<span>도서관위치 현황</span>
						<IoIosArrowForward className="arrow" />
					</div>
					<div id="cultPerf" className="item" onClick={this.openSearchWrap}>
						{/*	<img className="logo" alt="공연시설 현황" src="/sis/images/map/culture/icInformation.png" />*/}
						<span>공연시설 현황</span>
						<IoIosArrowForward className="arrow" />
					</div>
					<div id="cultExhi" className="item" onClick={this.openSearchWrap}>
						{/*	<img className="logo" alt="전시시설 현황" src="/sis/images/map/culture/icInformation.png" />*/}
						<span>전시시설 현황</span>
						<IoIosArrowForward className="arrow" />
					</div>
					
					<div id="cultDist" className="item" onClick={this.openSearchWrap}>
						{/*	<img className="logo" alt="지방문화원 현황" src="/sis/images/map/culture/icInformation.png" />*/}
						<span>지방문화원 현황</span>
						<IoIosArrowForward className="arrow" />
					</div>
				</div>

				<div className="searchWrap">{searchElement}</div>
			</div>
		);
	}
}

export default connect(
	(state) => ({
		sis: state.sisMap,
	}),
	(dispatch) => ({
		actions: bindActionCreators(sisMapActions, dispatch),
	})
)(Culture);
